<template>
    <AppErrorPage>
        <template v-slot:errorCode>
            {{ $rawText('403') }}
        </template>
        <template v-slot:errorMessage>
            {{ $t('lang_403.PERMISSION_DENIED') }}
        </template>
    </AppErrorPage>
</template>

<script>
import AppErrorPage from '@/app/core/components/AppErrorPage/AppErrorPage.vue';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'App403Page',
    components: { AppErrorPage },
});
</script>
